import type { AnalyticsEventPayload, UIAnalyticsEvent } from '@atlaskit/analytics-next';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { LoomCJNIneligibilityReason } from './eligibility.tsx';

type CreateAnalyticsEvent = (payload: AnalyticsEventPayload) => UIAnalyticsEvent;

export const fireEligibilityChecked = (
	createAnalyticsEvent: CreateAnalyticsEvent,
	ineligibilityReason: LoomCJNIneligibilityReason,
) =>
	fireTrackAnalytics(createAnalyticsEvent({}), 'eligibility checked', {
		flagKey: 'twcg-442-cjn-jira-loom',
		ineligibilityReason,
	});

export const fireExperimentError = (createAnalyticsEvent: CreateAnalyticsEvent, error: Error) =>
	fireErrorAnalytics({
		meta: {
			id: 'errorEvent_CJN_JiraToLoom',
			packageName: 'jiraCrossJoinNudges',
		},
		error,
		sendToPrivacyUnsafeSplunk: true,
	});

export const fireFeatureExposed = (createAnalyticsEvent: CreateAnalyticsEvent) => {
	fireTrackAnalytics(createAnalyticsEvent({}), 'feature exposed', {
		flagKey: 'twcg-442-cjn-jira-loom',
		cohort: expVal('twcg-442-cjn-jira-loom', 'cohort', 'not-enrolled'),
		ineligibilityReason: null, // we only fire this event if the user is eligible
	});
};
